import { useTranslation } from 'react-i18next';

export default function LatestBooksTitle() {
    const { i18n } = useTranslation();

    return (
        <>
            {i18n.language === "ar" ? (
                <div className="d-flex justify-content-between  flex-column">
                    <h1>أحدث الكتب</h1>
                    <p>التي لدينا في منصة الكتب … قم بزيارة منصة الكتب </p>
                </div>
            ) : (
                <div className="d-flex justify-content-between  flex-column">
                    <h1>Latest Books</h1>
                    <p>That we have on the Library … Visit the books platform</p>
                </div>
            )}
        </>
    )
}

